import type React from 'react';
import styles from './screen-frame.module.scss';

export interface ScreenFrameProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * The frame every full-screen page sits in: a single column centred in the window, fluid from 320px,
 * capped at 440px wide and, on desktop, 900px high. Children are laid out top to bottom in the column.
 */
export const ScreenFrame: React.FC<ScreenFrameProps> = ({ children, className }) => (
  <div className={[styles.screen, className].filter(Boolean).join(' ')}>
    <div className={styles.column}>{children}</div>
  </div>
);
